import ApiAcces from "@/shared/services/ApiAcces";

export interface PersonalAccessToken {
  id: string;
  name: string;
  prefix: string;
  createdAt: string;
  expiresAtUtc: string | null;
  lastUsedAtUtc: string | null;
  revokedAtUtc: string | null;
}

export interface CreatedToken {
  id: string;
  name: string;
  prefix: string;
  expiresAtUtc: string | null;
  /** Valor crudo del token — solo se devuelve al crearlo. */
  token: string;
}

export default class PersonalAccessTokenService extends ApiAcces {
  async list(): Promise<PersonalAccessToken[]> {
    const { data } = await this.api.get<PersonalAccessToken[]>("/api/auth/tokens");
    return data;
  }

  async create(name: string, expiresAtUtc?: string | null): Promise<CreatedToken> {
    const { data } = await this.api.post<CreatedToken>("/api/auth/tokens", {
      name,
      expiresAtUtc: expiresAtUtc ?? null,
    });
    return data;
  }

  async revoke(id: string): Promise<void> {
    await this.api.delete(`/api/auth/tokens/${id}`);
  }
}
